module.exports = __webpack_public_path__ + "static/apple-touch-icon-977ece639f3b7c249c1c697a5749e572.png";